import { Component, OnInit, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { SwUpdate, UnrecoverableStateEvent, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { GetAllSettingsAction } from './ngrx/setting/settings.action';
import { ProductsState } from './ngrx/products.reducer';
import { ChatPushService } from './services/chat-push.service';
import { I18nService } from './services/i18n.service';

const UPDATE_SILENT_RELOAD_WINDOW_MS = 10_000;
const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

  state: ProductsState | null = null;

  constructor(
    private updateService: SwUpdate,
    private metaTagService: Meta,
    private store: Store<any>,
    private snackBar: MatSnackBar,
    private i18n: I18nService,
    private zone: NgZone,
    // Instancié dès le démarrage : garde l'abonnement push rattaché au compte connecté
    private chatPush: ChatPushService,
  ) {}
  ngOnInit() {
    this.store.dispatch(new GetAllSettingsAction({}));
    this.metaTagService.addTags ([
      { name: "robots", content:"index, follow"},
      { charset:"UTF-8"},
      { name:"description", content:"Les meilleures offres et codes promo ! Ne chercher pas loin les promotions et les réductions ici les meilleures affaires ⇒ sur promodeep.com."},
      { name:"keywords", content:"offres, codes promo, promotions, réductions, bon plan"},
      { name:"author", content:"TechnoDeep"},
      { name:"viewport", content:"width=device-width, initial-scale=1.0, minimum-scale=0.5, maximum-scale=3.0"},
      { name:"apple-mobile-wep-app-capable", content:"yes"},
      { name:"mobile-wep-app-capable", content:"yes"},
      { name:"theme-color", content:"#1976d2"},

      // { name:"apple-itunes-app", content:"app-id=123456789"},
      // { name:"google-play-app", content:"app-id=com.promodeep.apps.android"}
      // { name:"google-site-verification", content:""},
      // { property:"prt", content:"0123456789"},
    ]);
    if (!this.updateService.isEnabled) {
      return;
    }
    this.handleUpdates();
  }

  // Le service worker sert d'abord la version en cache et télécharge la nouvelle
  // en arrière-plan : sans ce code, une livraison n'apparaît qu'au rechargement suivant.
  handleUpdates(): void {
    const startedAt = Date.now();
    this.updateService.versionUpdates
      .pipe(filter((event: VersionEvent): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        // Nouvelle version détectée juste à l'ouverture : on recharge directement,
        // l'utilisateur n'a encore rien fait sur l'ancienne version.
        if (Date.now() - startedAt < UPDATE_SILENT_RELOAD_WINDOW_MS) {
          document.location.reload();
          return;
        }
        this.snackBar
          .open(this.i18n.t('pwa.updateAvailable'), this.i18n.t('pwa.reload'), { verticalPosition: 'top' })
          .onAction()
          .subscribe(() => document.location.reload());
      });

    // Onglet resté ouvert longtemps : vérifie périodiquement s'il y a une livraison.
    // Hors zone, sinon l'app n'est jamais « stable » (cf. registerWhenStable).
    this.zone.runOutsideAngular(() =>
      setInterval(() => this.updateService.checkForUpdate().catch(() => {}), UPDATE_CHECK_INTERVAL_MS)
    );

    this.updateService.unrecoverable.subscribe((_event: UnrecoverableStateEvent) => {
      document.location.reload();
    });
  }

}
